import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

import { useAppContext } from '../hooks/AppProvider';

const StyledDiv = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});

const Proxy = () => <div />;

const AnimationContainer = ({ lazy }) => {
  const [content, setContent] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const { reducedMotion } = useAppContext();

  React.useEffect(() => {
    if (reducedMotion) {
      setContent(<Proxy />);
      setLoading(false);
      return () => null;
    }
    let abort = false;
    const lazyLoad = async () => {
      const result = await lazy();
      if (!abort) {
        setContent(<result.Component />);
        setLoading(false);
      }
    };
    lazyLoad();
    return () => {
      abort = true;
    };
  }, [lazy, reducedMotion]);

  return (
    <StyledDiv>
      {loading ? <Proxy /> : content}
    </StyledDiv>
  );
};

AnimationContainer.propTypes = {
  lazy: PropTypes.func.isRequired,
};

export default AnimationContainer;
